import React from 'react';
import Theme from '../../Theme';
const defaultProps = {
    title: '',
    args: [],
    height: 40,
    ticketCheckins: 0,
    afiliateName: ''
};
const BarSaleView = ({ title, args, height, handleResetCount, ticketCheckins, afiliateName }) => {
    let result = '';
    args = args || defaultProps.args;
    args.forEach((value, index, array) => {
        if (index < array.length) {
            result += `${value} \n`;
        }
        else {
            result += `${value}`;
        }
    });
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'column', } },
        React.createElement("div", { style: {
                height: Theme.size.bar,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: Theme.color.hairline,
                justifyItems: 'center', paddingLeft: 5, paddingRight: 5
            } },
            afiliateName && React.createElement("span", { style: { fontWeight: 'bold', flex: 5 } }, afiliateName),
            React.createElement("p", { style: { marginBottom: 0, marginTop: 0, flex: 11, textAlign: 'end', fontSize: 16 } }, `${result}`))));
};
export default BarSaleView;



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/BarSale.tsx
// module id = 158
// module chunks = 0